























import { Component, Mixins, Vue, Watch } from "vue-property-decorator";
import * as ChartModel from "../models/ChartModel";
import * as EntryPoint from "@/entryPoint";
import APIHeaders from '../entities/APIHeaders';
import LineChart from '../components/charts/LineChart.vue'
import APIHeaderBuilder from '../models/APIHeaderBuilder';
import store from '../store';

@Component({
  components: {
    LineChart
  }
})

export default class WeeklyChart extends Vue {
  //dataはそのままクラスのプロパティとして宣言
  loaded: boolean = false
  chartData: any = null
  options: any = null
  childId?: number
  toDate?: string
  chartHight: number = window.innerHeight　//仮でwindowの高さにしておく

  // // データをwatchしてChartをアップデート
  // @Watch('chartData')
  // onTextChanged(newText: any, oldText: any) {
  //    this.$data._chart.update()
  // }

  beforeDestroy() {
    EntryPoint.removeCallback()
  }

  mounted() {
    // クエリパラメータを取得
    this.childId = +this.$route.query.child_id
    if (isNaN(this.childId)) {
      return
    }
    if (this.$route.query.to_date != null ){
      this.toDate = decodeURIComponent(this.$route.query.to_date as string)
    }
    
    // Chartの高さを設定
    if(this.$refs.nav instanceof Element) {
      this.chartHight = window.innerHeight - (this.$refs.nav as Element).clientHeight
    }

// WeeklyChartができるまでコメントアウト
    // すでにStoreにapiアクセス用のHeaderがあれば、Chartデータをロード
    const headers = store.getters.apiHeadersOrNull
    if (headers != null) {
      this.loadChartData(headers)
    }
    // なければ、ブラウザからグラフデータの取得をキックしたときのコールバックを設定
    else{
      EntryPoint.setCallback(
        async(params: any) => {
          store.state.apiHeaders = APIHeaderBuilder(params)
        this.loadChartData(APIHeaderBuilder(params))
      })
    }
  }

  loadChartData(headers: APIHeaders) {
    ChartModel.weeklyForAMonth(headers, this.childId!, this.toDate as string)
      .then(result => {
        this.chartData = {
          labels: result.map(v => v.date+"~"),//月曜日の日付に~を追加
          datasets: [
            {
              // label: 'Data One',
              // borderColor: '#ffcce1',
              // backgroundColor: '#ff80b3',
              borderColor: '#8fc8d8',
              backgroundColor: '#149bdf',
              fill: false,
              cubicInterpolationMode: 'monotone',
              data: result.map(v => v.value)
            },
          ]
        }
        this.options = {
          spanGaps : false,
          responsive: true,
          maintainAspectRatio: false,
          legend:{
           display: false
         },
         scales: {
            yAxes: [{
                ticks: {
                    min:35,
                    max:41,
                    stepSize: 1.0
                },
                afterTickToLabelConversion : function(q:any){
                    for(var tick in q.ticks){
                        q.ticks[tick] += '\u00B0C';//単位を追加
                    }
                }
            }]
          }
        }
        this.loaded = true
      })
  }
}
